<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">保险行业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          橡诺科技财险业务系统基于客户中心理念设计，能够实现业务处理全过程管理，支持多级管理体系架构，支持集中控制、分散展业的业务处理模式，是一套支持财产保险公司业务处理的完美系统，并且随着技术的发展，橡诺科技已实现云部署，能够全面支持互联网保险公司或传统保险公司的互联网业务模式。<br>
          该系统基于SOA架构设计，充分应用WEB技术、通讯技术、影像技术，为保险公司提供全面稳定、高效先进的核心业务管理平台，能有效帮助保险公司控制业务风险，降低运营成本，提升客户服务水平和市场竞争力。<br>
          从应用架构上，该系统分为业务模块和管理模块两大模块。
          <div class="img"><img src="@/assets/img/solution/3/1.png"></div>
        </div>
        <div class="title-sub">系统特点</div>
        <div class="text">
          稳定可靠<br>
          系统设计充分屏蔽单点故障隐患，可用率高达99.9%；<br>
          系统服务器采用分布式部署方式，有效实现应用互备和可扩展性；<br>
          数据库服务器采用双机热备，保证系统运行稳定，数据安全可靠；<br>
          系统统一事务管理，保证交易完整及数据可靠；<br>
          高性能、高并发<br>
          采用多级缓存策略：浏览器段静态资源缓存；浏览器段下拉框数据缓存，通过数据版本管理自动更新；<br>
          服务器端缓存：web层静态资源缓存；APP静态数据缓存；Dao层数据缓存<br>
          易维护、可扩展<br>
          支持数据日志记录，并把异常交易有效记录到数据库中；<br>
          支持标准接口，支持与其它系统交互，可随需增加部署节点，应需扩容；<br>
          良好开发能力<br>
          系统开发平台独立；<br>
          模块化web开发模式；<br>
          组件管理框架；<br>
          系统开发模式化；<br>
          程序开发规范化；
        </div>
        <div class="title-sub">系统功能</div>
        <div class="text">
          橡诺科技财险核心系统主要功能包括：承保管理、理赔管理、再保管理、收付管理、单证管理、客户管理、产品管理、查询报表、系统设置、系统管理。
          <div class="img"><img src="@/assets/img/solution/3/2.png"></div>
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>